export const InfoPopupActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    SET_HEADER_CONTENT: 'SET_HEADER_CONTENT',
    SET_HEADER_ON_CLOSE_CLICK: 'SET_HEADER_ON_CLOSE_CLICK',
    ADD_BODY_CONTENT: 'ADD_BODY_CONTENT',
    SET_BODY_BUTTON_TEXT: 'SET_BODY_BUTTON_TEXT',
    SET_BODY_BUTTON_ON_CLICK: 'SET_BODY_BUTTON_ON_CLICK',
    SET_BODY_UPPER_IMAGE_PATH: 'SET_BODY_UPPER_IMAGE_PATH',
    SET_BODY_LOWER_IMAGE_PATH: 'SET_BODY_LOWER_IMAGE_PATH',
    SET_DISPATCHER: 'SET_DISPATCHER',
    SHOW_CLOSE_BUTTON: 'SHOW_CLOSE_BUTTON',
};
